<template>
    <b-card no-body>
        <b-card-body>
            <h4 class="heading-1 mb-4">
                <span>CONTRATOS -
                    {{
                        operacao == 'I'
                            ? 'NOVA REQUISIÇÃO'
                            : 'ATUALIZAÇÃO DA REQUISIÇÃO'
                    }}</span>
            </h4>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Contrato</label>
                        <model-list-select :list="contratos" option-text="codContratoFornecedor"
                            option-value="idContrato" v-model="idContrato" :isDisabled="desabilitarAlterarContrato">
                        </model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div v-if="contrato">
                        <div class="text-left ml-2 mb-2">
                            <b-row>
                                <div class="col pr-0">
                                    {{ "Vigência" }}
                                    &nbsp;
                                    <strong>
                                        {{
                                            `${$moment(contrato.dtInicioVigencia).format('DD/MM/YYYY')}`
                                        }}
                                        a
                                        {{
                                            $moment(contrato.dtFimVigencia).format(
                                                'DD/MM/YYYY'
                                            )
                                        }}
                                    </strong>
                                </div>
                            </b-row>
                        </div>
                        <div class="text-left ml-2 mb-2">
                            <b-row>
                                <div class="col pr-0">
                                    {{ "Saldo do Contrato" }}
                                    &nbsp;
                                    <strong>
                                        {{
                                            contrato.nuSaldoContrato | currency
                                        }}
                                    </strong>
                                </div>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div v-if="contrato">
                <b-row>
                    <b-col sm="12" md="4" lg="2" v-if="contrato && contrato.utilizarProcesso" class="mt-4">
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div v-if="processo">
                            <detalhe titulo="Interessado" :size="size1">{{
                                processo.nome
                                }}</detalhe>
                            <detalhe titulo="Criado por" :size="size1">{{
                                processo.cadastradoPor
                                }}</detalhe>
                            <detalhe titulo="Unidade" :size="size1">{{
                                processo.unidade
                                }}</detalhe>
                        </div>
                    </b-col>
                </b-row>
                <div>
                    <h5 class="heading-1 mb-4 mt-4">
                        <span>DADOS SOLICITANTE</span>
                    </h5>
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label>Nome</label>
                                <b-form-input type="text" v-model="solicitante" :disabled="true"></b-form-input>
                            </b-form-group>
                        </b-col><b-col sm="12" md="4">
                            <b-form-group>
                                <label>Email</label>
                                <b-form-input type="text" v-model="emailSolicitante" :disabled="true"></b-form-input>
                            </b-form-group>
                        </b-col><b-col sm="12" md="4">
                            <b-form-group>
                                <label>Contato</label>
                                <b-form-input type="text" v-model="contatoSolicitante" :disabled="false"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <h5 class="heading-1 mb-4 mt-4">
                    <span>DADOS REQUISIÇÃO</span>
                </h5>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Objeto</label>
                            <b-form-textarea v-model="objeto" :rows="4"
                                :disabled="naoPermiteAtualizar"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Informação complementar</label>
                            <b-form-textarea v-model="textoComplementar" :rows="4"
                                :disabled="naoPermiteAtualizar"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Data da Necessidade</label>
                            <date-picker v-model="dataNecessidade" :config="$datePickerOptions2" v-mask="'##/##/####'"
                                :disabled="naoPermiteAtualizar"></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Data Inicial Evento</label>
                            <date-picker v-model="dataInicialEvento" :config="$datePickerOptions2" v-mask="'##/##/####'"
                                :disabled="naoPermiteAtualizar"></date-picker>
                            <div v-if="$v.dataInicialEvento.$error" class="text-danger mt-1">
                                <small v-if="!$v.dataInicialEvento.required">Data Inicial Evento é obrigatória</small>
                                <small v-if="!$v.dataInicialEvento.validDataEvento">A Data Inicial Evento não pode ser maior que a Data Final Evento</small>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Data Final Evento</label>
                            <date-picker v-model="dataFinalEvento" :config="$datePickerOptions2" v-mask="'##/##/####'"
                                :disabled="naoPermiteAtualizar"></date-picker>
                            <div v-if="$v.dataFinalEvento.$error" class="text-danger mt-1">
                                <small v-if="!$v.dataFinalEvento.required">Data Final Evento é obrigatória</small>
                                <small v-if="!$v.dataFinalEvento.validDataEvento">A Data Inicial Evento não pode ser maior que a Data Final Evento</small>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div v-if="contrato">
                <h5 class="heading-1 mb-4 mt-4">
                    <span>DADOS APROVADOR REQUISIÇÃO</span>
                </h5>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Nome</label>
                            <model-list-select :list="solicitantes" option-text="nome" option-value="codFuncionario"
                                v-model="codAprovadorServico" :isDisabled="naoPermiteAtualizar">
                            </model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Email</label>
                            <b-form-input type="text" v-model="emailAprovadorServico" :disabled="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Contato</label>
                            <b-form-input type="text" v-model="telefoneAprovadorServico"
                                :disabled="naoPermiteAtualizar"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button variant="primary" :disabled="desabilitarBtnSalvar" v-if="!naoPermiteAtualizar"
                @click.stop="confirmaSalvar()">
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import RequisicoesServicos from './RequisicoesServicos'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        operacao: {
            type: String
        },

        errosPai: {
            type: Array
        },

        requisicao: {
            type: Object
        },

        naoPermiteAtualizar: {
            type: Boolean,
            default: () => false
        },
        rotaListagem: {
            type: String,
            default: () => null

        },
        rotaDetalhar: {
            type: String,
            default: () => null
        },
    },

    components: {
        ModelListSelect
    },

    data() {
        return {
            size1: '130',
            erros: [],
            contratos: [],
            contrato: null,
            idContrato: null,
            numProcesso: null,
            processo: null,
            objeto: null,
            textoComplementar: null,
            contatoSolicitante: null,
            dataNecessidade: null,
            dataInicialEvento: null,
            dataFinalEvento: null,
            codSolicitante: 0,
            solicitantes: [],
            naoRequerAutorizacaoEnvio: false,
            solicitante: this.$store.getters.usuario.nome,
            emailSolicitante: this.$store.getters.usuario.email,
            codAprovadorServico: 0,
            emailAprovadorServico: null,
            telefoneAprovadorServico: null
        }
    },

    methods: {
        voltar() {
            const rota = this.operacao === 'A' && this.rotaDetalhar ? this.rotaDetalhar : this.rotaListagem;
            this.$router.push({
                name: rota,
                params: this.operacao === 'A' && this.rotaDetalhar ? { requisicaoId: this.$route.params.idRequisicao } : {}
            })
        },

        obterContratos() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterContratos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                        if (this.operacao == 'A') {
                            this.preencherFormulario()
                        }
                    } else {
                        this.erros.push('Erro ao obter contratos')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterContrato(this.idContrato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.obterSolicitantes()
                        } else {
                            this.erros.push('Erro ao obter contrato')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        preencherFormulario() {
            this.idContrato = this.requisicao.idContrato
            this.numProcesso = this.requisicao.processo
            this.objeto = this.requisicao.objeto
            this.textoComplementar = this.requisicao.textoComplementar
            this.contatoSolicitante = this.requisicao.contatoSolicitante
            this.solicitante = this.requisicao.solicitante;
            this.emailSolicitante = this.requisicao.emailSolicitante;
            this.dataNecessidade = this.$moment(
                this.requisicao.dataNecessidade
            ).format('DD/MM/YYYY')
            this.dataInicialEvento = this.requisicao.dtInicioEvento ? this.$moment(
                this.requisicao.dtInicioEvento
            ).format('DD/MM/YYYY') : null
            this.dataFinalEvento = this.requisicao.dtFimEvento ? this.$moment(
                this.requisicao.dtFimEvento
            ).format('DD/MM/YYYY') : null
            this.codSolicitante = this.requisicao.codSolicitante
            this.naoRequerAutorizacaoEnvio =
                this.requisicao.naoRequerAutorizacaoEnvio
            this.codAprovadorServico = this.requisicao.codAprovadorServico
            this.telefoneAprovadorServico = this.requisicao.contatoAprovadorServico
            if (this.requisicao.informadoProcesso) {
                this.obterProcesso()
            }
        },

        obterProcesso() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterProcesso(
                this.numProcesso,
                this.operacao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.erros = []
                        this.processo = response.data
                    } else {
                        this.erros.push(response.errors[0])
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterSolicitantes() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterSolicitantes().then((response) => {
                if (response) {
                    if (response.success) {
                        this.solicitantes = response.data
                        if (this.codAprovadorServico > 0) {
                            const solicitanteSelecionado = this.solicitantes.find(s => s.codFuncionario.toString() == this.codAprovadorServico);
                            if (solicitanteSelecionado) {
                                this.codAprovadorServico = solicitanteSelecionado.codFuncionario;
                            }
                        }
                    } else {
                        this.erros.push('Erro ao obter solicitantes')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaSalvar() {
            let acao = ''
            let titulo = ''
            if (this.operacao == 'I') {
                acao = 'a inserção'
                titulo = 'Inserção'
            } else if (this.operacao == 'A') {
                acao = 'a atualização'
                titulo = 'Atualização'
            }

            this.$swal({
                title: titulo,
                html: `Confirma ${acao} da requisição para o contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            if(this.codSolicitante == 0){
                const solicitanteObterCod = this.solicitantes.find(s => s.email == this.emailSolicitante);
                
                if (solicitanteObterCod) {
                    this.codSolicitante = solicitanteObterCod.codFuncionario;
                }
                else{
                    this.codSolicitante = this.$store.getters.usuario.login.slice(2)
                }
            }
            
            
            
            let requisicaoDto = {
                idContrato: this.idContrato,
                numProcesso: '',
                naoRequerAutorizacaoEnvio: this.naoRequerAutorizacaoEnvio,
                objeto: this.objeto,
                textoComplementar: this.textoComplementar,
                codSolicitante: this.codSolicitante,
                contatoSolicitante: this.contatoSolicitante,
                dataNecessidade: this.$moment(
                    this.dataNecessidade,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dataInicialEvento: this.dataInicialEvento ? this.$moment(
                    this.dataInicialEvento,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD') : null,
                dataFinalEvento: this.dataFinalEvento ? this.$moment(
                    this.dataFinalEvento,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD') : null,
                requisicaoOrigemExterna: true,
                codAprovadorServico: this.codAprovadorServico,
                contatoAprovadorServico: this.telefoneAprovadorServico,
            }
            if (this.contrato.utilizarProcesso) {
                requisicaoDto.numProcesso = this.numProcesso
            }
            console.log(requisicaoDto)
            this.$emit('salvar', requisicaoDto)
        }
    },

    created() {
        this.obterContratos()
        this.dataNecessidade = this.$moment(new Date()).format('DD/MM/YYYY')
        if (this.errosPai) {
            this.erros = [...this.errosPai]
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        desabilitarAlterarContrato() {
            if (
                this.requisicao &&
                this.requisicao.comprometimentos &&
                this.requisicao.comprometimentos.length > 0
            ) {
                return true
            }
            if (
                this.requisicao &&
                this.requisicao.itens &&
                this.requisicao.itens.length > 0
            ) {
                return true
            }
            return false
        },

        validacaoDataEvento() {
            if (!this.dataInicialEvento || !this.dataFinalEvento) {
                return false
            }
            
            const dataInicial = this.$moment(this.dataInicialEvento, 'DD/MM/YYYY')
            const dataFinal = this.$moment(this.dataFinalEvento, 'DD/MM/YYYY')
            
            return dataInicial.isAfter(dataFinal)
        }
    },

    watch: {
        idContrato() {
            this.obterContrato()
        },

        processo() {
            this.objeto = this.processo ? this.processo.assunto : null
        },

        errosPai() {
            this.erros = [...this.errosPai]
        },
        codAprovadorServico() {
            if (this.codAprovadorServico) {
                const solicitanteSelecionado = this.solicitantes.find(s => s.codFuncionario === this.codAprovadorServico);
                if (solicitanteSelecionado) {
                    this.emailAprovadorServico = solicitanteSelecionado.email;
                }
            }
        }
    },

    validations: {
        idContrato: {
            required
        },
        objeto: {
            required
        },
        dataNecessidade: {
            required
        },
        dataInicialEvento: {
            required,
            validDataEvento() {
                return !this.validacaoDataEvento
            }
        },
        dataFinalEvento: {
            required,
            validDataEvento() {
                return !this.validacaoDataEvento
            }
        },
    }
}
</script>
